var map = {
	"./Slice 26@2x(0).png": 7524,
	"./Slice 26@2x(1).png": 4587,
	"./Slice 26@2x(10).png": 17,
	"./Slice 26@2x(11).png": 2282,
	"./Slice 26@2x(12).png": 2187,
	"./Slice 26@2x(2).png": 8346,
	"./Slice 26@2x(3).png": 4385,
	"./Slice 26@2x(4).png": 1776,
	"./Slice 26@2x(5).png": 2471,
	"./Slice 26@2x(6).png": 9814,
	"./Slice 26@2x(7).png": 9053,
	"./Slice 26@2x(8).png": 316,
	"./Slice 26@2x(9).png": 4851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 333;